export default class TurnGraph {
    constructor(amount = 0) {
        this.latest = 0;
        this.latestChange = null;
        this.points = {};
        this.max = 0;
        this.queue = 0;
        this.latest = amount;
    }
    add(amount) {
        this.queue += amount;
    }
    setValue(amount) {
        this.queue = amount - this.latest;
    }
    turn(turn) {
        this.latest += this.queue;
        this.points[turn] = this.latest;
        this.latestChange = this.queue;
        this.max = Math.max(this.max, this.latest);
        this.queue = 0;
    }
}
